var mobileMenuToggle, mobileToggleChildren;

mobileMenuToggle = function() {
  return $('.mobile-menu-toggle').on('click', function() {
    return $('body').toggleClass("mobileNav-open");
  });
};

mobileToggleChildren = function() {
  var toggleLink;
  toggleLink = $('.mobile-menu .toggle-children');
  return toggleLink.on('click', function(e) {
    var $link, targetId;
    e.preventDefault();
    $link = $(this);
    targetId = $link.attr('href');
    $link.toggleClass('showing-children');
    $(targetId).toggleClass('show-children');
    return false;
  });
};

$(function() {
  mobileMenuToggle();
  return mobileToggleChildren();
});

// ---
// generated by coffee-script 1.9.2